export class EnvService {
  public static get API_URL(): string {
    return process.env.REACT_APP_API_URL as string;
  }

  public static get CHAT_BROADCASTER(): string {
    return process.env.REACT_APP_CHAT_BROADCASTER as string;
  }

  public static get CHAT_KEY(): string {
    return process.env.REACT_APP_CHAT_KEY as string;
  }

  public static get CHAT_CLUSTER(): string {
    return process.env.REACT_APP_CHAT_CLUSTER as string;
  }

  public static get MODULE_ACCOUNTING_TOGGLE(): string {
    return process.env.REACT_APP_MODULE_ACCOUNTING_TOGGLE as string;
  }

  public static get MODULE_KYC_TOGGLE(): string {
    return process.env.REACT_APP_MODULE_KYC_TOOGLE as string;
  }

  public static get REACT_APP_SJ_SISTEMAS(): string {
    return process.env.REACT_APP_SJ_SISTEMAS as string;
  }

  public static get REACT_APP_APP(): string {
    return process.env.REACT_APP_APP as string;
  }

  public static get REACT_APP_STAGING(): string {
    return process.env.REACT_APP_STAGING as string;
  }

  public static get REACT_APP_LOCALHOST(): string {
    return process.env.REACT_APP_LOCALHOST as string;
  }
}
